import { render, staticRenderFns } from "./FullDescriptionItem.vue?vue&type=template&id=a8be417c"
import script from "./FullDescriptionItem.vue?vue&type=script&lang=js"
export * from "./FullDescriptionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports